/**
 * Created by Ivan on 26.10.2025
 */

const LevelMasteryMerge2Adapter = {
    SubscribeToEvents: function () {
        cleverapps.missionManager.on("add", (mission) => {
            if (!Merge2.current) {
                return;
            }
            if (mission.getType() === Mission.TYPE_LEVEL_MASTERY) {
                cleverapps.eventBus.trigger("updateExtraBar");
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        cleverapps.missionManager.on("remove", (mission) => {
            if (mission.getType() === Mission.TYPE_LEVEL_MASTERY) {
                cleverapps.extraBar.removeIcon(LevelMasteryExtraBarIcon);
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        cleverapps.missionManager.on("clickReceiveButton", (type) => {
            if (type !== Mission.TYPE_LEVEL_MASTERY) {
                return;
            }

            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_LEVEL_MASTERY);
            if (!mission || !mission.isRunning() || !mission.logic.isStageCompleted()) {
                return;
            }

            mission.logic.updateIcon();

            let rewards = {};
            while (mission.logic.isStageCompleted()) {
                const stage = mission.logic.getCurrentStage();
                rewards = RewardsList.sumRewards(rewards, stage.prize);
                mission.logic.updateStage();
            }

            cleverapps.focusManager.display({
                focus: "levelMasteryReward",
                stack: true,
                actions: [
                    function (f) {
                        new RewardWindow(new RewardsList(rewards, {
                            event: cleverapps.EVENTS.EARN.LEVELMASTERY,
                            toBubbleStack: true
                        }));
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    },
                    function (f) {
                        const ViewClass = mission.isRunning() && mission.getViewClass();
                        if (!ViewClass) {
                            f();
                            return;
                        }

                        new ViewClass(mission);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                ]
            });
        });

        cleverapps.eventBus.on("earn_stars", (amount) => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_LEVEL_MASTERY);
            if (mission && mission.isRunning()) {
                mission.logic.incLevel(amount);
            }
        });

        cleverapps.eventBus.on("updateExtraBar", () => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_LEVEL_MASTERY);
            if (!mission || !mission.isRunning()) {
                return;
            }

            if (cleverapps.resolution.isVertical()) {
                cleverapps.extraBar.removeIcon(LevelMasteryExtraBarIcon, true);
            } else {
                cleverapps.extraBar.addIcon(LevelMasteryExtraBarIcon);
            }
        });
    }
};

cleverapps.whenAllInitialized(() => LevelMasteryMerge2Adapter.SubscribeToEvents());